import {
  DEALER_TOP_AVG_TREND,
  DEALER_TOP_DEPARTMENT_GRAPH,
  DEALER_TOP_FILTER,
  DEALER_TOP_PART_DETAILS,
  DEALER_TOP_REPORT,
  DEALER_TOP_TABLE_DATA,
} from "../../config/apiList";
import { contentType, methodType } from "../../config/auth";
import { apiRequest } from "../../utility/apiWrapper";

export const getDepartmentGraph = (department, page, limit, type) => {
  const requestURL = DEALER_TOP_DEPARTMENT_GRAPH;
  let obj = { type: type };

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

// Dealer, Distributor, Dealer_And_Distributor
export const getDealerTableData = (type, page, limit, parts, sortColumn, sortOrder) => {
  const requestURL = DEALER_TOP_TABLE_DATA;
  let obj = { type: type };

  if (parts && parts.length) {
    obj["part_list"] = parts.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, sort_column: sortColumn, sort_order: sortOrder },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDealerFilter = () => {
  const requestURL = DEALER_TOP_FILTER;

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: {},
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDealerAverageTrendData = (
  startDate,
  endDate,
  page,
  limit,
  type
) => {
  const requestURL = DEALER_TOP_AVG_TREND;
  let obj = { from_date: startDate, to_date: endDate, type: type };

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDealerReport = (startDate, endDate, type, department) => {
  const requestURL = DEALER_TOP_REPORT;
  let obj = { from_date: startDate, to_date: endDate, type: type };

  if (department && department.length) {
    obj["dept_list"] = department.join(",");
  }

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: obj,
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getDealerPartDetails = (page, limit, type, search) => {
  const requestURL = DEALER_TOP_PART_DETAILS;
  let obj = { type: type };

  const reqParams = {
    method: methodType.GET,
    url: requestURL,
    data: { ...obj, page: page, limit: limit, search: search },
    contentType: contentType.APPLICATION,
    isAuthorized: true,
  };

  return apiRequest(reqParams)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};
